// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"45e54217","71":"de4f5f51","142":"971d842e","351":"ceac27dc","508":"10f32944","970":"9b38c800"}[chunkId] + ".css";
};